import features from './features/loans.features';
import components from './components/loans.components';
import common from './common/loans.common';
import loansService from './loans.service';
import toastr from 'angular-toastr';
import toastUtils from './../common/utils/toastUtils';

let loansModule = angular.module('loans', [
  common,
  features,
  components,
  toastr,
])

  .config( ($translatePartialLoaderProvider, toastrConfig, $windowProvider) => {
    'ngInject';
    toastUtils.setGlobalConfig(toastrConfig, $windowProvider.$get().isMobileApp);
    $translatePartialLoaderProvider.addPart('loans.module');
  })

  .service('loansService', loansService)

  .name;

export default loansModule;



// WEBPACK FOOTER //
// ./client/app/loans.module/loans.module.js